import React from 'react';
import { Box, Typography } from '@mui/material';
import PuffLoader from 'react-spinners/PuffLoader';

const Loading = ({ text }) => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      flexDirection='column'
      alignItems='center'
      gap={5}
      height='100vh' // Full viewport height to center it vertically.
    >
      <PuffLoader size={100} />
      <Typography variant='h6' color='textSecondary' align='center'>
        {text}
      </Typography>
    </Box>
  );
};

export default Loading;
